const base = {
  state: {
    bizToken: '',
    loading: false,
    knowTipsMask: true,
    hideHeyue: true,
    hideDingdan: true,
    hideRepair: true,
    hideBaojie: true,
    orderRoomUrl: '',
    userid: 0,
    openid: '',
    fullname: '',
    phone: '',
    renting: {
      rent: {},
      renewRent: {},
      house: {
        id: 0,
        name: '',
        address: ''
      },
      room: {
        id: 0,
        name: ''
      }
    },
    nopayBill: [],
    keeper: {},
    filterHouseList: [],
    wechatBindBackUrl: ''
  },
  getters: {
    hasRenew: state => state.renting.renewRent && state.renting.renewRent.status === 'PRE_CONFIRM',
    getWechatBindBackUrl(state){
      return state.wechatBindBackUrl
    },
    getFilterHouseList(state) {
      return state.filterHouseList
    }
  },
  mutations: {
    setWechatBindBackUrl(state, wechatBindBackUrl){
      state.wechatBindBackUrl = wechatBindBackUrl
    },
    setBizToken(state, bizToken) {
      state.bizToken = bizToken
    },
    setUserId(state, userid) {
      state.userid = userid
    },
    setOpenId(state, openid) {
      state.openid = openid
    },
    setFullName(state, fullname) {
      state.fullname = fullname
    },
    setPhone(state, phone) {
      state.phone = phone
    },
    setRent(state, rent) {
      state.renting.rent = rent
    },
    setRenewRent(state, rent) {
      state.renting.renewRent = rent
    },
    setHouse(state, house) {
      state.renting.house = house
    },
    setRoom(state, room) {
      state.renting.room = room
    },
    setReport(state, report) {
      state.report = report
    },
    setNopayBill(state, nopayBill) {
      state.nopayBill = nopayBill
    },
    setKeeper(state, keeper) {
      state.keeper = keeper
    },
    setHeyue(state, heyue) {
      state.hideHeyue = heyue
    },
    setBaojie(state, baojie) {
      state.hideBaojie = baojie
    },
    setDingdan(state, dingdan) {
      state.hideDingdan = dingdan
    },
    setRepair(state, repair) {
      state.hideRepair = repair
    },
    setOrderRoomUrl(state, orderRoomUrl) {
      state.orderRoomUrl = orderRoomUrl
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    hideKnowHouseMask(state, knowTipsMask) {
      state.knowTipsMask = knowTipsMask
    },
    setFilterHouseList(state, filterHouseList) {
      state.filterHouseList = filterHouseList
    }
  },
  actions: {}
}

export default base


// WEBPACK FOOTER //
// ./src/store/base.js